<template>
  <router-view />
</template>

<script>
import { onMounted, onUnmounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { authService } from '@/services/authService'
import { generalSettingsService } from '@/services/generalSettingsService'
import { companiesService } from '@/services/companiesService'
import { sessionLockService } from '@/services/sessionLockService'
import { tokenRefreshService } from '@/services/tokenRefreshService'
import { usersService } from '@/services/usersService'
import '@/plugins/styles'
export default {
  name: 'App',
  setup() {
    const store = useStore()
    const router = useRouter()
    store.dispatch('setting/setSetting')
    const sidebarType = computed(() => store.getters['setting/sidebar_type'])
    const resizePlugin = () => {
      const sidebarResponsive = document.querySelector('[data-sidebar="responsive"]')
      if (window.innerWidth < 1025) {
        if (sidebarResponsive !== null) {
          if (!sidebarResponsive.classList.contains('sidebar-mini')) {
            sidebarResponsive.classList.add('on-resize')
            store.dispatch('setting/sidebar_type', [...sidebarType.value, 'sidebar-mini'])
          }
        }
      } else {
        if (sidebarResponsive !== null) {
          if (sidebarResponsive.classList.contains('sidebar-mini') && sidebarResponsive.classList.contains('on-resize')) {
            sidebarResponsive.classList.remove('on-resize')
            store.dispatch(
              'setting/sidebar_type',
              sidebarType.value.filter((item) => item !== 'sidebar-mini')
            )
          }
        }
      }
    }
    onMounted(async () => {
      window.addEventListener('resize', resizePlugin)
      setTimeout(() => {
        resizePlugin()
      }, 200)

      if (authService.isAuthenticated()) {
        try {
          const settings = generalSettingsService.getCached() || (await generalSettingsService.fetchAll())
          sessionLockService.configure(settings)
          await companiesService.getAll()
        } catch {
          sessionLockService.configure({ sessionTimeoutMinutes: 60 })
        }
        await sessionLockService.bootstrap(router)
        tokenRefreshService.start()
        await usersService.refreshCurrentUserPhoto()
      }
    })
    onUnmounted(() => {
      window.removeEventListener('resize', resizePlugin)
    })
  }
}
</script>

<style lang="scss">
@import '@/assets/custom-vue/scss/styles.scss';
</style>
